import { FunctionComponent, useMemo } from 'react'
import ReactMarkdown from 'react-markdown'
import { normalizeAssistantMarkdown } from '../utils/normalizeAssistantMarkdown'
import { AssistantMarkdownProps } from './AssistantMarkdown.model'
import styles from './AssistantMarkdown.module.scss'

export const AssistantMarkdown: FunctionComponent<AssistantMarkdownProps> = ({ text }) => {
  const normalized = useMemo(() => normalizeAssistantMarkdown(text), [text])

  return (
    <div className={styles.markdown}>
      <ReactMarkdown
        components={{
          h2: ({ children }) => <h3 className={styles.heading}>{children}</h3>,
          h3: ({ children }) => <h4 className={styles.subheading}>{children}</h4>,
          p: ({ children }) => <p className={styles.paragraph}>{children}</p>,
          ul: ({ children }) => <ul className={styles.list}>{children}</ul>,
          ol: ({ children }) => <ol className={styles.list}>{children}</ol>,
          li: ({ children }) => <li className={styles.listItem}>{children}</li>,
          strong: ({ children }) => <strong className={styles.strong}>{children}</strong>,
        }}
      >
        {normalized}
      </ReactMarkdown>
    </div>
  )
}
